import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";
import "react-loading-skeleton/dist/skeleton.css";
import { SkeletonTheme } from "react-loading-skeleton";
const root = ReactDOM.createRoot(document.getElementById("root"));

const options = {
  api_host: "https://app.posthog.com",
};
root.render(
  // <React.StrictMode>
  <PostHogProvider
    apiKey={"phc_x4P4ncYcrfhXyUrdpNC8EG9kbOPjTKpKEMX9wbmiyXU"}
    options={options}
  >
    <BrowserRouter>
      <SkeletonTheme baseColor="gray" highlightColor="white">
        <App />
      </SkeletonTheme>
    </BrowserRouter>
  </PostHogProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
